module.exports = __webpack_public_path__ + "img/2.a8678b54.jpg";